import { BookmarkCheck, Users, User } from "lucide-react";

const GameCard = ({ game, isLoading, onClick }) => {
  const IconComponent = game.icon;

  return (
    <div onClick={()=>onClick(game)} className="block cursor-pointer">
      <div className="space-y-3 bg-gradient-to-b from-[#190003] to-red-500 rounded-lg p-6 text-white hover:bg-red-700 transition-colors duration-300 h-full flex flex-col justify-between">
        <div>
          <div className="text-4xl mb-2">
            <img src={IconComponent} className="w-12 h-12" alt={game.name} />
          </div>
          <div className="flex items-center gap-2">
          <h3 className="text-xl font-bold">{game.name}</h3>
          {game.isRegistered && <div className="text-white flex gap-1 items-center text-sm rounded-full bg-green-500/70 p-1 px-2"><BookmarkCheck className="size-4" /> Registered</div> }
          </div>
        </div>

        <div className="flex items-center">
          {game.type === "single" ? <User className="w-5 h-5 mr-2" /> : <Users className="w-5 h-5 mr-2" />}
          <span className="text-sm">{game.type === "single" ? "Single Player" : "Multiplayer"}</span>
        </div>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <div className="flex gap-2 items-center">
            <BookmarkCheck className="size-5" />
            <div className="text-sm">
              Registrations: <span className="font-bold">{game.registrations || 0}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameCard;